function e(e){if(!e)return"";let l=e;return l=l.replace(/\D/g,""),l.length>3&&l.length<=6?l=l.slice(0,3)+" "+l.slice(3):l.length>6&&(l=l.slice(0,3)+" "+l.slice(3,6)+" "+l.slice(6,10)),l}export{e as default};
//# sourceMappingURL=mobile-number-formatter.js.map
